import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import "./AdminPage.css";
import { useMsal } from "@azure/msal-react";
import KeyData from "../KeyData.json";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Alert from "@mui/material/Alert";
import SampleExcel from "../../data/KeyStatistics-Sample.xlsx";
import axios from "axios";
import mailData from "../../data/mailData.js";
import { baseURL } from "../../Constant.js";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "0.1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
};

const AdminPage = ({ setBool }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  };

  // on change states
  const [excelFile, setExcelFile] = useState(null);
  const [excelFileError, setExcelFileError] = useState(null);
  const [boolData, setBoolData] = useState(false);
  const [inputChange, setInputChange] = useState("");
  const [alert, setAlert] = useState(false);

  const [excelData, setExcelData] = useState(null);

  const [show, setShow] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const { instance } = useMsal();

  const usersList = [
    `${mailData.aluruakash}`,
    `${mailData.lavanyaumesh}`,
    `${mailData.dslavanyaumesh}`,
    `${mailData.rashishrivastava}`,
    `${mailData.dsdevaluruakash}`,
    `${mailData.umaranibattu}`,
    `${mailData.dsdevumaranibattu}`,
    `${mailData.jeevadharaniramanan}`,
    `${mailData.reshmiharidasm}`,
    `${mailData.dsdevreshmiharidasm}`,
    `${mailData.ankuremishra}`,
    `${mailData.dsdevankuremishra}`,
    `${mailData.aayushibharti}`,
    `${mailData.dsdevaayushibharti}`,
    `${mailData.arpitamsingh}`,
    `${mailData.dsdevarpitamsingh}`,
    `${mailData.jbbhardwaj}`,
    `${mailData.varshaatyagi}`,
    `${mailData.hsrinivasan}`,
    `${mailData.yogendratrivedi}`,
    `${mailData.jbmittal}`,
    `${mailData.dsdevjbmittal}`,
    `${mailData.bprasadmishra}`
  ];

  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount) {
      const val = usersList.some((item) => item === activeAccount.username)
        ? setShowUser(true)
        : "Byee";

      console.log(val);
    } else {
      console.log("Something Wrong.....!");
    }
  }, [activeAccount]);

  const handleAlertClose = () => {
    setAlert(false);
  };

  alert && setTimeout(handleAlertClose, 3000);

  const handleFile = (e) => {
    let selectedFile = e.target.files[0];
    setInputChange(selectedFile);
    if (selectedFile) {
      // console log selectedFile.type
      if (selectedFile) {
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFileError(null);
          // setExcelFile(e.target.result);
          const workbook = XLSX.read(e.target.result, { type: "buffer" });
          const worksheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[worksheetName];
          const data = XLSX.utils.sheet_to_json(worksheet);
          console.log(data, "data while reading");
          setExcelData(data);
        };
      } else {
        setExcelFileError("Please select only excel file types");
        console.log(selectedFile.type, ":ttytytpe");
        setExcelFile(null);
      }
    } else {
      console.log("Please select your file");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalData = [
      excelData[0]["Number of ASEs inducted"],
      excelData[0]["Number of Streams Delivered"],
      excelData[0]["Number of Cohorts Instituted"],
      excelData[0]["Number of ASEs achieved P2 Proficiency"],
      excelData[0]["Number of ASEs Onboarded"],
    ];

    console.log(finalData, "finalDataaaaa");

    axios
      .post(
        `${baseURL}/uploadStatistics/`,
        // `http://localhost:3002/uploadStatistics`,
        {
          finalData,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log(response);
        alert("Deatils updated successfully");
      })
      .catch((error) => {
        console.log(error);
      });
    setBool(true);
    // window.location.reload(true);
  };

  return (
    <>
      {console.log(excelData, "excel dataaaaaaaaaa")}
      <div className="alert-container">
        {alert && (
          <Alert onClose={handleAlertClose} className="alert-line">
            Updated Successfully!!
          </Alert>
        )}
      </div>
      {showUser && (
        <div className="admin_container">
          {/* MUI Modal  */}
          <Button onClick={handleOpen} className="admin-button">
            Admin
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal-box-container">
              <div className="modal-box-wrap">
                <h2>File Upload</h2>
                <hr></hr>
                <img
                  src="images/AdminPage/CloseIcon.png"
                  onClick={handleClose}
                  alt="close-icon"
                  className="close-button"
                ></img>

                <form
                  onSubmit={handleSubmit}
                  className="modal-box-form"
                  id="form"
                >
                  <div>
                    <label>Select File to Upload :</label>
                    <div className="upload-form">
                      <input
                        type="file"
                        className="mainData"
                        accept=".xlsx"
                        // ref={ref}
                        id="file"
                        onChange={handleFile}
                      />
                      <label htmlFor="file" className="file_lable">
                        &uArr; Upload File
                      </label>
                      <span className="file_caption">
                        {inputChange.name
                          ? inputChange.name
                          : "No File Selected"}
                      </span>
                    </div>
                  </div>
                  <div className="submit-btn-container">
                    <Button
                      type="submit"
                      className="submit-btn"
                      disabled={inputChange === "" ? true : false}
                      onClick={() =>
                        setTimeout(() => {
                          setAlert(true);
                          handleClose();
                        }, 500)
                      }
                    >
                      Publish Data
                    </Button>
                    {/* {console.log(alert, "alert")} */}
                  </div>
                </form>
                <div className="instructions-container">
                  <span className="key-statistics-upload-instructions">
                    Instructions
                  </span>
                  <div>
                    <ol className="Instructions-List">
                      <li>
                        To publish the data by uploading the template, in case
                        if there is any doubt or clarification please refer the{" "}
                        <a
                          href="images/AdminPage/Job-Aid-for-Key-Statistics.docx"
                          className="key-statistics-sample-file"
                        >
                          job aid
                        </a>
                        .
                      </li>
                      <li>
                        The data needs to be uploaded in a given template
                        format. Any change in the template will lead to upload
                        failure or error messages.
                        <a
                          href={SampleExcel}
                          target="_blank"
                          className="key-statistics-sample-file"
                          rel="noreferrer"
                        >
                          {" "}
                          Click here{" "}
                        </a>
                        to download the data template.{" "}
                        <strong>Do not modify</strong> the column name and order
                        of the column in the template.
                      </li>
                      <li>
                        For a successful upload of new Key Statistics data every
                        time use new excel file, avoid making changes to the
                        older one.
                      </li>
                      <li>
                        Please avoid uploading or updating the data frequently
                        to avoid any issues. In case if any corrections required
                        and its unavoidable please re-upload the excel file
                        again and publish the data.
                      </li>
                      {/* <li>
                              Please do not exceed maximum three times of uploading or correcting the calendar for the respective 
                              month as per the governance and terms.
                          </li>*/}
                      {/* <li>
                        Uploaded data can be modified to the max of 3 times.
                      </li> */}
                      <li>
                        In case if you need to add or remove access for admin
                        page please contact{" "}
                        <a
                          href={`mailto:${mailData.atciPortaldevelopment}`}
                          className="key-statistics-sample-file"
                        >
                          {mailData.atciPortaldevelopment}
                        </a>
                      </li>
                      <li>
                        Whenever there is a change in the Key Statistics page,
                        admins will be notified via mail
                      </li>
                      <li>
                        The members who have admin access :
                        <table className="table_Names">
                          <tr>
                            <td>h.srinivasan</td>
                            <td>jeevadharani.ramanan</td>
                            <td>aayushi.bharti</td>
                            <td>uma.rani.battu</td>
                            <td>yogendra.trivedi</td>
                          </tr>
                          <tr>
                            <td>arpita.m.singh</td>
                            <td>aluru.akash</td>
                            <td>ankur.e.mishra</td>
                            <td>rajath.mb</td>
                            <td>j.b.bhardwaj</td>
                          </tr>
                          <tr>
                            <td>reshmi.haridas.m</td>
                            <td>shramika.s.ambolkar</td>
                            <td>varsha.a.tyagi</td>
                            <td>j.b.mittal</td>
                          </tr>
                        </table>
                      </li>
                    </ol>
                    <br></br>
                  </div>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
};

export default AdminPage;
